
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"26","rx":"2","fill":"#fff"}}),_c('path',{attrs:{"d":"M38 1H2v23h36V1z","fill":"#fff"}}),_c('path',{attrs:{"d":"M37.42 20.264H2.613v3.153H37.42v-3.153z","fill":"#FCB316"}}),_c('path',{attrs:{"d":"M37.42 1.617H2.613v3.154H37.42V1.617zM16.523 8.198l-3.58 8.603h-2.352L8.818 9.946c-.102-.411-.204-.583-.511-.754-.546-.274-1.398-.549-2.182-.72l.068-.24h3.784c.477 0 .92.309 1.023.891l.886 4.936 2.319-5.861h2.318zm9.204 5.793c0-2.263-3.136-2.4-3.102-3.428 0-.309.307-.651.954-.72a4.358 4.358 0 012.182.377l.375-1.817a5.79 5.79 0 00-2.08-.377c-2.181 0-3.75 1.166-3.75 2.845 0 1.234 1.092 1.92 1.944 2.331.852.412 1.16.686 1.16 1.063 0 .582-.683.822-1.33.857-1.125.034-1.773-.309-2.284-.549l-.41 1.92c.512.24 1.466.445 2.455.445 2.352 0 3.852-1.13 3.886-2.947zm5.796 2.81h2.045l-1.807-8.603h-1.909c-.409 0-.784.24-.954.617L25.557 16.8h2.318l.477-1.302h2.83l.34 1.302zm-2.489-3.05l1.16-3.222.681 3.222h-1.84zm-9.34-5.553l-1.842 8.638h-2.216l1.841-8.638h2.216z","fill":"#10357F"}})])
          )
        }
      }
    